import React from 'react';
import { Container, Button, Carousel } from 'react-bootstrap';
import dietPub from "../../../images/pubWell/StockCake-Focused.jpg";
import wokout from "../../../images/pubWell/StockCake-IntenseGym.jpg";
import mes from "../../../images/pubWell/StockCake-HealthyBreakfast.jpg";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const HeaderCarousel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Carousel>
      <Carousel.Item>
        <div className="text-white text-center py-5" style={{ height: '700px', backgroundImage: `url(${dietPub})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <Container className="d-flex flex-column justify-content-center h-100">
            <div className="bg-primary-light my-5">
              <h1 className="text-black">{t('landing.carousel.slide1.title')}</h1>
              <h3 className="text-black-50">{t('landing.carousel.slide1.subtitle')}</h3>
            </div>
            <Button onClick={() => navigate("/login")} variant="primary" size="lg" className="mx-auto">
              {t('landing.carousel.slide1.button')}
            </Button>
          </Container>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="text-white text-center py-5" style={{ height: '700px', backgroundImage: `url(${wokout})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <Container className="d-flex flex-column justify-content-center h-100">
            <div className="bg-primary-light my-5">
              <h1 className="text-black">{t('landing.carousel.slide2.title')}</h1>
              <h3 className="text-black-50">{t('landing.carousel.slide2.subtitle')}</h3>
            </div>
            <Button onClick={() => navigate("/login")} variant="primary" size="lg" className="mx-auto">
              {t('landing.carousel.slide2.button')}
            </Button>
          </Container>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="text-white text-center py-5" style={{ height: '700px', backgroundImage: `url(${mes})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <Container className="d-flex flex-column justify-content-center h-100">
            <div className="bg-primary-light my-5">
              <h1 className="text-black">{t('landing.carousel.slide3.title')}</h1>
              <h3 className="text-black-50">{t('landing.carousel.slide3.subtitle')}</h3>
            </div>
            <Button onClick={() => navigate("/login")} variant="primary" size="lg" className="mx-auto">
              {t('landing.carousel.slide3.button')}
            </Button>
          </Container>
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default HeaderCarousel;